export enum UserRoleType {
  endUser = 'endUser',
  maintainer = 'maintainer',
  maintainerDeputy = 'maintainerDeputy',
  maintainerAdmin = 'maintainerAdmin',
  maintainerCEO = 'maintainerCEO',
  supportLocalReadOnly = 'supportLocalReadOnly',
  supportLocalReadWrite = 'supportLocalReadWrite',
  supportLocalReadWriteWithRemoteDiagnosis = 'SupportLocalReadWriteWithRemoteDiagnosis',
  supportInternational = 'supportInternational',
  supportInternationalWithRemoteDiagnosis = 'SupportInternationalWithRemoteDiagnosis',
  supportLocalDepartmentManagement = 'supportLocalDepartmentManagement',
  admin = 'admin',
}

// Applicable to UserV2 model due to lack of backward compatibility
export enum UserRoleTypeUpperCase {
  endUser = 'EndUser',
  maintainer = 'Maintainer',
  maintainerDeputy = 'MaintainerDeputy',
  maintainerAdmin = 'MaintainerAdmin',
  maintainerCEO = 'MaintainerCEO',
  supportLocalReadOnly = 'SupportLocalReadOnly',
  supportLocalReadWrite = 'SupportLocalReadWrite',
  supportLocalReadWriteWithRemoteDiagnosis = 'SupportLocalReadWriteWithRemoteDiagnosis',
  supportInternational = 'SupportInternational',
  supportInternationalWithRemoteDiagnosis = 'SupportInternationalWithRemoteDiagnosis',
  supportLocalDepartmentManagement = 'SupportLocalDepartmentManagement',
  admin = 'Admin',
}

export enum RoleGroupType {
  Admin = 'Admin',
  Maintainer = 'Maintainer',
  SupportLocal = 'SupportLocal',
  SupportLocalReadWriteWithRemoteDiagnosis = 'SupportLocalReadWriteWithRemoteDiagnosis',
  SupportInternational = 'SupportInternational',
  SupportInternationalWithRemoteDiagnosis = 'SupportInternationalWithRemoteDiagnosis',
  SupportLocalDepartmentManagement = 'SupportLocalDepartmentManagement',
  User = 'User',
}
